import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDCPvIHHnrDueqL39fojL5Wn2WciMKDbGc",
  authDomain: "ki-studio.thegoodwins.de",
  projectId: "ki-tools-5505f",
  storageBucket: "ki-tools-5505f.firebasestorage.app",
  messagingSenderId: "418230332537",
  appId: "1:418230332537:web:6faac64c73f1f6ea95b8a8"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

export const ALLOWED_DOMAIN = 'thegoodwins.de';